import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
import { templates } from '@/utils/method'
import { TENANTID } from '@/store/mutation-types'

import homePage from '@/views/home'
import productPage from '@/views/product'
import proDetailPage from '@/views/product/detail'
import cartPage from '@/views/cart'
import orderPage from '@/views/order'
import orderDetailPage from '@/views/order/detail'
import aboutPage from '@/views/about/index'
import contactPage from '@/views/about/contact'
import addressPage from "../views/address"
import newDetail from "@/views/about/newDetail"
import news from "@/views/news"
import newsDetail from "@/views/news/detail"
import video from "@/views/video"
import login from "@/views/login"
import brandDetail from "@/views/brand/detail"
import auditaccount from "@/views/audit" // 国安审核账号页面
import hotProduct from "@/views/hotProduct"
import newProduct from "@/views/newProduct"
import international from "@/views/international"
import userGuide from "@/views/userGuide"
import loginPage from '@/components/memberModal/loginPage.vue'
import regPage from '@/components/memberModal/regPage.vue'


Vue.use(VueRouter)
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
let pathName = '/home'
if (templates() === 'themeTemplateFour' || (templates() === 'themeTemplateOne' && TENANTID === 470761814249541)) {
    pathName = '/login'
} else {
    pathName = '/home'
}

const routes = [{
    path: '/',
    redirect: pathName
}, {
    name: 'home',
    path: '/home',
    component: homePage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'product',
    path: '/product',
    component: productPage,
    meta: {
        keepAlive: false // 开启缓存
    }
},
{
    name: 'proDetail',
    path: '/proDetail',
    component: proDetailPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'cart',
    path: '/cart',
    component: cartPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'order',
    path: '/order',
    component: orderPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'loginIn',
    path: '/loginIn',
    component: loginPage,
    meta: {
        keepAlive: false
    }
    },
{
    name: 'regPage',
    path: '/regPage',
    component: regPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'address',
    path: '/address',
    component: addressPage,
    meta: {
        keepAlive: false
    }
},

{
    name: 'orderDetail',
    path: '/order/detail',
    component: orderDetailPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'about',
    path: '/about',
    component: aboutPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'contact',
    path: '/contact',
    component: contactPage,
    meta: {
        keepAlive: false
    }
},
{
    name: 'newDetail',
    path: '/newDetail',
    component: newDetail,
    meta: {
        keepAlive: false
    }
},
{
    name: 'news',
    path: '/news',
    component: news,
    meta: {
        keepAlive: false
    }
},
{
    name: 'newsDetail',
    path: '/newsDetail',
    component: newsDetail,
    meta: {
        keepAlive: false
    }
},
{
    name: 'video',
    path: '/video',
    component: video,
    meta: {
        keepAlive: false
    }
},
{
    name: 'login',
    path: '/login',
    component: login,
    meta: {
        keepAlive: false
    }
},
{
    name: 'brandDetail',
    path: '/brandDetail',
    component: brandDetail,
    meta: {
        keepAlive: false
    }
},
{
    name: 'auditaccount',
    path: '/auditaccount',
    component: auditaccount,
    meta: {
        keepAlive: false
    }
},
{
    name: 'hotProduct',
    path: '/hotProduct',
    component: hotProduct,
    meta: {
        keepAlive: false
    }
},
{
    name: 'newProduct',
    path: '/newProduct',
    component: newProduct,
    meta: {
        keepAlive: false
    }
},
{
    name: 'international',
    path: '/international',
    component: international,
    meta: {
        keepAlive: false
    }
},
{
    name: 'userGuide',
    path: '/userGuide',
    component: userGuide,
    meta: {
        keepAlive: false
    }
}
]

const router = new VueRouter({
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    let obj = store.state.user
    /**
     * 470761814249541 华晟
     */
    if (templates() === 'themeTemplateFour' || (templates() === 'themeTemplateOne' && TENANTID === 470761814249541)) {
        if (obj.userInfo.id && obj.token) {
            if (to.name === 'login') {
                next('/home')
            } else {
                next()
            }
        } else {
            if (to.name !== 'login') {
                next('/')
            } else {
                next()
            }
        }
    } else {
        if (to.name === 'login') {
            next('/home')
        } else {
            next()
        }
    }
})

export default router